import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const HR = () => (
  <div>
    <Title level={3}>Recursos Humanos</Title>
    <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
      <Empty
        image={<UserOutlined style={{ fontSize: 64, color: '#6c5ce7' }} />}
        description={
          <div>
            <Title level={4} style={{ marginTop: 16 }}>Gestión de RRHH</Title>
            <Paragraph type="secondary">
              737 empleados: asistencia, nómina, vacaciones, onboarding. Integrado con Odoo HR.
            </Paragraph>
            <Paragraph type="secondary">Disponible en Fase 5</Paragraph>
          </div>
        }
      />
    </Card>
  </div>
);

export default HR;
